import cx from "clsx";
import { FileHandle } from "kreate-common/modules/business-types";
import { blobIdToUrl } from "kreate-env/client";
import React from "react";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  file: FileHandle | null | undefined;
  thumbnailFile: FileHandle | null | undefined;
  fill: true;
};

export default function PrimaryVideoViewer({
  className,
  style,
  file,
  thumbnailFile,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      {file ? (
        <video
          className={styles.video}
          controls
          loop
          preload="auto"
          poster={
            // TODO: @kien-kreate: loading the unoptimized thumbnail can be slow
            thumbnailFile ? blobIdToUrl(thumbnailFile.blob.blobId) : undefined
          }
        >
          <source
            src={blobIdToUrl(file.blob.blobId)}
            type={file.blob.contentType}
          />
        </video>
      ) : undefined}
    </div>
  );
}
